"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionLockLock_1 = require("../../../../../../shared/components/table_actions/TableActionLockLock");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionDollar_1 = require("../../../../../../shared/components/table_actions/TableActionDollar");
var FinanceReconciliationPartnersDetailExpander_1 = require("./FinanceReconciliationPartnersDetailExpander");
var FinanceReconciliationPartnersList = /** @class */ (function (_super) {
    __extends(FinanceReconciliationPartnersList, _super);
    function FinanceReconciliationPartnersList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Логин',
                dataIndex: _this.props.data.dk_usr_partner_login,
                key: _this.props.data.dk_usr_partner_login,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.usr_partner_login,
                        " [",
                        record.key,
                        "]"));
                }
            }, {
                title: 'Доход партнера',
                children: [{
                        title: 'С игроков',
                        dataIndex: _this.props.data.dk_amount,
                        key: _this.props.data.dk_amount,
                        width: 200,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, new Intl.NumberFormat().format(record.amount)));
                        }
                    }, {
                        title: 'С субагентов',
                        dataIndex: _this.props.data.dk_amount_sub,
                        key: _this.props.data.dk_amount_sub,
                        width: 200,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, new Intl.NumberFormat().format(record.amount_sub)));
                        }
                    }, {
                        title: 'Текущий баланс',
                        dataIndex: _this.props.data.dk_amount_before,
                        key: _this.props.data.dk_amount_before,
                        width: 200,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, new Intl.NumberFormat().format(record.amount_before)));
                        }
                    }]
            }, {
                title: 'Выплаты сформированы',
                children: [{
                        title: 'По игрокам',
                        dataIndex: _this.props.data.dk_usr_partner_flow_id_player,
                        key: _this.props.data.dk_usr_partner_flow_id_player,
                        width: 100,
                        render: function (text, record, idx) {
                            if (record.usr_partner_flow_id_player > 0) {
                                return (React.createElement("div", null,
                                    React.createElement("b", null, "\u0414\u0410")));
                            }
                            return (React.createElement("div", null, "\u041D\u0415\u0422"));
                        }
                    }, {
                        title: 'По субагентам',
                        dataIndex: _this.props.data.dk_usr_partner_flow_id_sub,
                        key: _this.props.data.dk_usr_partner_flow_id_sub,
                        width: 100,
                        render: function (text, record, idx) {
                            if (record.usr_partner_flow_id_sub > 0) {
                                return (React.createElement("div", null,
                                    React.createElement("b", null, "\u0414\u0410")));
                            }
                            return (React.createElement("div", null, "\u041D\u0415\u0422"));
                        }
                    }, {
                        title: 'Сброс минуса',
                        dataIndex: _this.props.data.dk_usr_partner_flow_id_sub,
                        key: _this.props.data.dk_usr_partner_flow_id_sub,
                        width: 100,
                        render: function (text, record, idx) {
                            if (record.usr_partner_flow_id_reset > 0) {
                                return (React.createElement("div", null,
                                    React.createElement("b", null, "\u0414\u0410")));
                            }
                            return (React.createElement("div", null, "\u041D\u0415\u0422"));
                        }
                    }]
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null, _this.getActionButtons(record))); },
                width: 110
            }
        ];
        return _this;
    }
    FinanceReconciliationPartnersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                //  dtFrom: data.dtFrom,
                //  dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
            dtFormat: this.props.state.getDateTimeFormat(),
            expand_subpartners: false,
            pageSize: this.props.state.getTablePageSize(),
            pageNum: 0,
        }, function () {
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    FinanceReconciliationPartnersList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    FinanceReconciliationPartnersList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.loadData(nextProps);
        }
    };
    FinanceReconciliationPartnersList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadDataByReconciliationList({
            usr_partner_reconciliation_id: Props.record.key
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    FinanceReconciliationPartnersList.prototype.onDeleteClick = function (record) {
        var _this = this;
        this.props.data.DeleteData(record.key, function () {
            _this.props.data.LoadDataByReconciliationList({ usr_partner_reconciliation_id: _this.props.record.key }, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0430\u0440\u0442\u043D\u0435\u0440 \u0434\u043B\u044F \u0441\u0432\u0435\u0440\u043A\u0438 ",
                    React.createElement("b", null,
                        "[",
                        record.usr_partner_login,
                        "]"),
                    " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
            });
        });
    };
    FinanceReconciliationPartnersList.prototype.onMakeWithdrawalsClick = function (record) {
        this.props.data.DoMakeFlowObjects(record.key, function (created) {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0417\u0430\u044F\u0432\u043A\u0438 \u043D\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 \u0432 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0435 ",
                React.createElement("b", null,
                    "[",
                    created,
                    "]"),
                " \u0448\u0442\u0443\u043A \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0434\u043B\u044F \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.usr_partner_login,
                    "]"),
                " !"));
        });
    };
    FinanceReconciliationPartnersList.prototype.getActionButtons = function (record) {
        var _this = this;
        var _ret = [];
        // if (record.is_pending) {
        if ((record.usr_partner_flow_id_player == 0) && (record.usr_partner_flow_id_sub == 0) && (record.usr_partner_flow_id_reset == 0)) {
            _ret.push(React.createElement(TableActionDollar_1.default, { hint: "\u0421\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u044B", onClick: function () { _this.onMakeWithdrawalsClick(record); }, key: "ab_1" }));
        }
        else {
            _ret.push(React.createElement(TableActionLockLock_1.default, { disabled: true, confirmText: "\u0421\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u044B", onClick: function () { }, key: "al_1" }));
        }
        if (!this.state.expand_subpartners) {
            _ret.push(React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430 \u0441\u0432\u0435\u0440\u043A\u0438 ?", onClick: function () { _this.onDeleteClick(record); }, key: "ab_2" }));
        }
        //} else {
        //    _ret.push(<TableActionLockLock disabled confirmText="Подтвердить выплату ?" onClick={() => { }} key={"al_1"} />);
        //    _ret.push(<TableActionLockLock disabled confirmText="Отменить выплату ?" onClick={() => { }} key={"al_2"} />);
        //}
        return _ret;
    };
    /* private onPageChanged(Page: number, PageSize: number) {
         let _page = Page;
         if (PageSize != this.state.pageSize) {
             _page = 1;
         }
         this.setState({ pageNum: _page, pageSize: PageSize }, () => {
             this.loadData(this.props);
         });
     }*/
    FinanceReconciliationPartnersList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
    };
    /*private doCalculateRevShares() {
        let _dtFrom = moment().startOf('month');
        let _dtTo = moment().add(0, 'd').set('hour', 0).set('minute', 0).set('second', 0);
        //
        this.props.dlgCalculateRevShare
            .SetDateFrom(_dtFrom)
            .SetDateTo(_dtTo)
            .SetTitle("Расчет revshare")
            .SetOnYesClick((dFrom, dTo, ignoreStart) => {

                this.props.data.DoGenerateRevshare({

                    pprograms: this.props.PProgramsList,
                    allPPrograms: this.props.allPPrograms,

                    from_year: dFrom.get('year'),
                    from_month: dFrom.get('month') + 1,
                    from_day: dFrom.get('date'),

                    to_year: dTo.get('year'),
                    to_month: dTo.get('month') + 1,
                    to_day: dTo.get('date'),

                    is_ignore_start_date: ignoreStart

                }, (generatedCount) => {
                    notificationHelper.ShowTopRightNotification(<div>Расчет вознаграждений окончен! Сгенерировано [{generatedCount}] вознаграждений</div>);
                    if (generatedCount > 0) {
                        this.loadData(this.props);
                    }
                });

            })
            .Show();
    }*/
    FinanceReconciliationPartnersList.prototype.onCheckBoxChecked = function (checked) {
        this.setState({ expand_subpartners: checked });
    };
    FinanceReconciliationPartnersList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement("div", { style: { marginLeft: "4px", display: "flex", flexWrap: "nowrap", justifyContent: "flex-start", alignItems: "center" } },
                    React.createElement(antd_1.Switch, { checked: this.state.expand_subpartners, onChange: this.onCheckBoxChecked.bind(this) }),
                    React.createElement("div", { style: { marginLeft: "2px", marginRight: "2px" } }, "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C \u0441\u0443\u0431\u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432"))),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    // onChange: this.onPageChanged.bind(this),
                    // onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    if (_this.state.expand_subpartners) {
                        return (React.createElement("div", null,
                            React.createElement(FinanceReconciliationPartnersDetailExpander_1.default, { state: _this.props.state, record: record, errDialog: _this.props.errDialog })));
                    }
                    else {
                        return null;
                    }
                }, expandRowByClick: this.state.expand_subpartners, expandIcon: function (props) {
                    props.expandable = _this.state.expand_subpartners;
                    if (props.expanded) {
                        return React.createElement("span", { className: "ant-table-row-expand-icon ant-table-row-expanded" }); //ant-table-row-expanded
                    }
                    else {
                        return React.createElement("span", { className: "ant-table-row-expand-icon ant-table-row-collapsed" }); //ant-table-row-expanded
                    }
                }, onExpand: function (expanded, record) {
                    //expanded
                }, scroll: { x: true } })));
    };
    return FinanceReconciliationPartnersList;
}(React.Component));
exports.default = FinanceReconciliationPartnersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_reconciliations/ui/component/FinanceReconciliationPartnersList.tsx
// module id = 2556
// module chunks = 0